export default {
    setPagePreloaderIsActive({ commit }, payload)
    {
        commit('setPagePreloaderIsActiveMutation', payload);
    },
}
